import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import _ from 'lodash'

const initialState = {
	selectedRestaurantId: '',
	userId: '',
	loadedData: {} as any,
	organizationLogo: '',
	stripePublishableKey: '',
	organizationLogoDark: '',
	emailLogo: '',
	webAppURL: '',
	iosAppId: '',
	restaurants: {} as any,
	referralCode: '',
	showKioskStartScreen: true,
	selectedPickupPoint: null as any,
	activeOrder: null as any,
	allDataLoaded: false,
	restaurantList: [] as any[],
	dataIsDoneLoading: false,
	disableIdleTimer: false,
	navContext: null as any,
	updateData: [] as any,
	userCurrentLocation: {} as any,
	restaurantIds: [] as string[],
	menuItemCategories: [] as any[],
	filteredCategories: [] as any[],
	showDeliveryModal: false,
}

type StateTypes = typeof initialState

const slice = createSlice({
	name: 'data',
	initialState,
	reducers: {
		setStates: (state, action: PayloadAction<Partial<StateTypes>>) => {
			Object.assign(state, action.payload)
		},
		updateLoadedData: (state, action: PayloadAction<Partial<typeof state.loadedData>>) => {
			const updates = action.payload
			for (const key in updates) {
				if (Object.prototype.hasOwnProperty.call(updates, key)) {
					state.loadedData[key] = updates[key] // Add or replace the key in loadedData
				}
			}
		},
		updateShowDeliveryModal: (state, action) => {
			state.showDeliveryModal = action.payload
		},
	},
})

const { setStates, updateLoadedData, updateShowDeliveryModal } = slice.actions

export const setDataState = (updates: Partial<StateTypes>) => setStates(updates)

export const setLoadedData = (updates: Partial<typeof initialState.loadedData>) =>
	updateLoadedData(updates)

export const setShowDeliveryModal = (value: boolean) => updateShowDeliveryModal(value)

export default slice.reducer
